import React, {useEffect} from "react";
const MedicalRecords =()=> {
       useEffect(() => {
                const scriptUrls = [
                  "assets/js/jquery-3.7.1.min.js",
                  "assets/js/bootstrap.bundle.min.js",
                  "assets/plugins/select2/js/select2.min.js",
                  "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
                  "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
                  "assets/js/moment.min.js",
                  "assets/js/bootstrap-datetimepicker.min.js",
                  "assets/plugins/bootstrap-tagsinput/js/bootstrap-tagsinput.js",
                  "assets/js/script.js"
                ];
            
                let isCancelled = false;
            
                const loadScriptsSequentially = async () => {
                  for (const url of scriptUrls) {
                    if (isCancelled) break;
            
                    await new Promise((resolve, reject) => {
                      const script = document.createElement('script');
                      script.src = url;
                      script.async = false;
                      script.onload = () => {
                        console.log(`Loaded: ${url}`);
                        resolve();
                      };
                      script.onerror = () => {
                        console.error(`Failed to load: ${url}`);
                        reject();
                      };
                      document.body.appendChild(script);
                    });
                  }
            
                  // Now init plugins after scripts are loaded
                  if (!isCancelled) {
                    // if (window.AOS) {
                    //   window.AOS.init();
                    // }
            
                    if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                      window.$('.datetimepicker').datetimepicker();
                    }
            
                    if (typeof window.initBackToTop === 'function') {
                      window.initBackToTop(); // assuming your backToTop script defines this
                    }
            
                    console.log('All scripts loaded and initialized.');
                  }
                };
            
                loadScriptsSequentially();
            
                return () => {
                  isCancelled = true;
                };
              }, []);
    return (
        <>
<div className="col-lg-8 col-xl-9">
  <div className="dashboard-header flex-wrap">
    <h3>Records</h3>
    <div className="appointment-tabs">
      <ul className="nav">
        <li>
          {/* <a> */}
          <button type="button" className="nav-link active" data-bs-toggle="tab" data-bs-target="#medical">
            Medical Records
          </button>
          {/* </a> */}
        </li>
        <li>
          {/* <a> */}
          <button type="button" className="nav-link" data-bs-toggle="tab" data-bs-target="#prescription">
            Prescriptions
          </button>
          {/* </a> */}
        </li>
      </ul>
    </div>
  </div>
  <div className="tab-content pt-0">
    {/* Prescription Tab */}
    <div className="tab-pane fade" id="prescription">
      <div className="dashboard-header border-0 m-0">
        <ul className="header-list-btns">
          <li>
            <div className="input-block dash-search-input">
              <input type="text" className="form-control" placeholder="Search" />
              <span className="search-icon"><i className="isax isax-search-normal" /></span>
            </div>
          </li>
        </ul>
      </div>
      <div className="custom-table">
        <div className="table-responsive">
          <table className="table table-center mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Created Date</th>
                <th>Prescriped By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_prescription">
                    #P1236
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon prescription">
                    Prescription
                  </a>
                  {/* </a> */}
                </td>
                <td>24 Mar 2024, 10:30 AM</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!"  className="avatar avatar-sm me-2" onClick={() => window.location.href = "doctor-profile/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-02.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "doctor-profile/"}>
                      Edalin Hendry
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#view_prescription">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" type="button">
                      <i className="isax isax-import" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </a>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>		
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_prescription">
                    #P3656
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon prescription">
                    Prescription
                  </a>
                  {/* </a> */}
                </td>
                <td>27 Mar 2024, 11:15 AM</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!" className="avatar avatar-sm me-2" onClick={() => window.location.href = "doctor-profile/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-05.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "doctor-profile/"}>
                      John Homes
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#view_prescription">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!">
                      <i className="isax isax-import" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </a>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>		
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_prescription">
                    #P1246
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon prescription">
                    Prescription
                  </a>
                  {/* </a> */}
                </td>
                <td>11 Apr 2024, 09:00 AM</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!" className="avatar avatar-sm me-2" onClick={() => window.location.href = "doctor-profile/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-03.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "doctor-profile/"}>
                      Shanta Neill
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#view_prescription">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!">
                      <i className="isax isax-import" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </a>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_prescription">
                    #P6985
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon prescription">
                    Prescription
                  </a>
                  {/* </a> */}
                </td>
                <td>15 Apr 2024, 02:30 PM</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!" className="avatar avatar-sm me-2" onClick={() => window.location.href = "doctor-profile/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-08.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "doctor-profile/"}>
                      Anthony Tran
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#view_prescription">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!">
                      <i className="isax isax-import" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </a>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_prescription">
                    #P3659
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon prescription">
                    Prescription
                  </a>
                  {/* </a> */}
                </td>
                <td>23 Apr 2024, 06:40 PM</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!" className="avatar avatar-sm me-2" onClick={() => window.location.href = "doctor-profile/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors/doctor-thumb-01.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "doctor-profile/"}>
                      Susan Lingo
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!"data-bs-toggle="modal" data-bs-target="#view_prescription">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!">
                      <i className="isax isax-import" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </a>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* Pagination */}
      <div className="pagination dashboard-pagination">
        <ul>
          <li>
            {/* <a> */}
            <a href="#!" className="page-link prev">
              Prev
            </a>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <a href="#!" className="page-link">
              1
            </a>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <a href="#!" className="page-link active">
              2
            </a>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <a href="#!" className="page-link">
              3
            </a>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <a href="#!" className="page-link">
              4
            </a>
            {/* </a> */}
          </li>	
          <li>
            {/* <a> */}
            <a href="#!" className="page-link next">
              Next
            </a>
            {/* </a> */}
          </li>
        </ul>
      </div>
      {/* /Pagination */}
    </div>
    {/* /Prescription Tab */}
    {/* Medical Records Tab */}
    <div className="tab-pane fade show active" id="medical">
      <div className="dashboard-header border-0 m-0">
        <ul className="header-list-btns">
          <li>
            <div className="input-block dash-search-input">
              <input type="text" className="form-control" placeholder="Search" />
              <span className="search-icon"><i className="isax isax-search-normal" /></span>
            </div>
          </li>
        </ul>
        {/* <a> */}
        <a href="#!" className="btn btn-md btn-primary-gradient rounded-pill" data-bs-toggle="modal" data-bs-target="#add_medical_records">
          Add Medical Record
        </a>
        {/* </a> */}
      </div>
      <div className="custom-table">
        <div className="table-responsive">
          <table className="table table-center mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Date</th>
                <th>Record For</th>
                <th>Comments</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_report">
                    #MR1236
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon">
                    Electro cardiography
                  </a>
                  {/* </a> */}
                </td>
                <td>24 Mar 2024</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!" className="avatar avatar-sm me-2" onClick={() => window.location.href = "patient-details/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors-dashboard/profile-06.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "paitent-details/"}>
                      Hendrita Clark
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>Take Good Rest</td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#view_report">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#edit_medical_records">
                      <i className="isax isax-edit-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!">
                      <i className="isax isax-import" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </a>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <a> */}
                  <a href="#!" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_report">
                    #MR3656
                  </a>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <a href="#!" className="lab-icon">
                    Complete Blood Count	
                  </a>
                  {/* </a> */}
                </td>
                <td>27 Mar 2024</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <a href="#!" className="avatar avatar-sm me-2" onClick={() => window.location.href = "patient-details/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors-dashboard/profile-05.jpg" alt="User " />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <a href="#!" onClick={() => window.location.href = "paitent-details/"}>
                      Laura Stewart
                    </a>
                    {/* </a> */}
                  </h2>
                </td>
                <td>Stable, no change</td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <a href="#!" data-bs-toggle="modal" data-bs-target="#view_report">
                      <i className="isax isax-link-2" />
                    </a>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#edit_medical_records">
                      <i className="isax isax-edit-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button">
                      <i className="isax isax-import" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </button>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <a> */}
                  <button type="button" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_report">
                    #MR1246
                  </button>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <button type="button" className="lab-icon">
                    Blood Glucose Test
                  </button>
                  {/* </a> */}
                </td>
                <td>10 Apr 2024</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <button type="button" className="avatar avatar-sm me-2" onClick={() => window.location.href = "patient-details/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors-dashboard/profile-02.jpg" alt="User" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" onClick={() => window.location.href = "paitent-details/"}>
                      Mathew Charles&nbsp;
                    </button>
                    {/* </a> */}
                  </h2>
                </td>
                <td>All Clear</td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#view_report">
                      <i className="isax isax-link-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#edit_medical_records">
                      <i className="isax isax-edit-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button">
                      <i className="isax isax-import" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </button>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <a> */}
                  <button type="button" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_report">
                    #MR6985
                  </button>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <button type="button" className="lab-icon">
                    Liver Function Tests
                  </button>
                  {/* </a> */}
                </td>
                <td>19 Apr 2024</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <button type="button" className="avatar avatar-sm me-2" onClick={() => window.location.href = "patient-details/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors-dashboard/profile-03.jpg" alt="User" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" onClick={() => window.location.href = "paitent-details/"}>
                      Christopher Joseph
                    </button>
                    {/* </a> */}
                  </h2>
                </td>
                <td>Stable, no change</td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#view_report">
                      <i className="isax isax-link-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#edit_medical_records">
                      <i className="isax isax-edit-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button">
                      <i className="isax isax-import" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </button>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* <a> */}
                  <button type="button" className="link-primary" data-bs-toggle="modal" data-bs-target="#view_report">
                    #MR3659
                  </button>
                  {/* </a> */}
                </td>
                <td>
                  {/* <a> */}
                  <button type="button" className="lab-icon">
                    Blood Cultures
                  </button>
                  {/* </a> */}
                </td>
                <td>27 Apr 2024</td>
                <td>
                  <h2 className="table-avatar">
                    {/* <a> */}
                    <button type="button" className="avatar avatar-sm me-2" onClick={() => window.location.href = "patient-details/"}>
                      <img className="avatar-img rounded-3" src="assets/img/doctors-dashboard/profile-08.jpg" alt="User" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" onClick={() => window.location.href = "paitent-details/"}>
                      Elisa Salcedo
                    </button>
                    {/* </a> */}
                  </h2>
                </td>
                <td>Take Good Rest</td>
                <td>
                  <div className="action-item">
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#view_report">
                      <i className="isax isax-link-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#edit_medical_records">
                      <i className="isax isax-edit-2" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button">
                      <i className="isax isax-import" />
                    </button>
                    {/* </a> */}
                    {/* <a> */}
                    <button type="button" data-bs-toggle="modal" data-bs-target="#delete_modal">
                      <i className="isax isax-trash" />
                    </button>
                    {/* </a> */}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* Pagination */}
      <div className="pagination dashboard-pagination">
        <ul>
          <li>
            {/* <a> */}
            <button type="button" className="page-link prev">
              Prev
            </button>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <button type="button" className="page-link">
              1
            </button>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <button type="button" className="page-link active">
              2
            </button>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <button type="button" className="page-link">
              3
            </button>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <button type="button" className="page-link">
              4
            </button>
            {/* </a> */}
          </li>
          <li>
            {/* <a> */}
            <button type="button" className="page-link next">
              Next
            </button>
            {/* </a> */}
          </li>
        </ul>
      </div>
      {/* /Pagination */}
    </div>
    {/* /Medical Records Tab */}
  </div>
</div>

  {/* Add Medical Records Modal */}
  <div className="modal fade custom-modals" id="add_medical_records">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">Add Medical Record</h3>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <form>					
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">Title <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">Record  For <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Date <span className="text-danger">*</span></label>
                  <div className="form-icon">
                    <input type="text" className="form-control datetimepicker" />
                    <span className="icon"><i className="isax isax-calendar-1" /></span>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Comments <span className="text-danger">*</span></label>
                  <textarea className="form-control" rows={3} defaultValue={""} />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Record <span className="text-danger">*</span></label>
                  <div>
                    <div className="file-upload">
                      <input type="file" />
                      <p><i className="isax isax-document-upload me-1" />Upload File</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">					
            <div className="modal-btn text-end">
              {/* <a> */}
              <button type="button" className="btn btn-md btn-dark rounded-pill" data-bs-toggle="modal" data-bs-dismiss="modal">
                Cancel
              </button>
              {/* </a> */}
              <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill">Add Medical Records</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  {/* /Add Medical Records Modal */}
  {/* Edit Medical Records Modal */}
  <div className="modal fade custom-modals" id="edit_medical_records">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">Edit Medical Record</h3>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <form>					
          <div className="modal-body pb-0">
            <div className="row">
              <div className="mb-3">
                <label className="col-form-label">Title</label>
                <input type="text" className="form-control" defaultValue="Glucose Test V12" />
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">Record  For <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" defaultValue="Hendrita Clark" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Date <span className="text-danger">*</span></label>
                  <div className="form-icon">
                    <input type="text" className="form-control datetimepicker" defaultValue="23/04/2024" />
                    <span className="icon"><i className="isax isax-calendar-1" /></span>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Comments <span className="text-danger">*</span></label>
                  <textarea className="form-control" rows={3} defaultValue={"Take Good Rest"} />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">Record <span className="text-danger">*</span></label>
                  <div>
                    <div className="file-upload">
                      <input type="file" />
                      <p><i className="isax isax-document-upload me-1" />Upload File</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">					
            <div className="modal-btn text-end">
              {/* <a> */}
              <button type="button" className="btn btn-md btn-dark rounded-pill" data-bs-toggle="modal" data-bs-dismiss="modal">
                Cancel
              </button>
              {/* </a> */}
              <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill">Save Medical Records</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  {/* /Edit Medical Records Modal */}		
  {/*View Report */}
  <div className="modal fade custom-modals" id="view_report">
    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">View Report</h3>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>				
        <div className="modal-body pb-0">
          <div className="prescribe-download gap-2">
            <h5>21 Mar  2024</h5>
            <ul>
              <li>
                {/* <a> */}
                <button type="button" className="print-link">
                  <i className="fa-solid fa-print" />
                </button>
                {/* </a> */}
              </li>
              <li>
                {/* <a> */}
                <button type="button" className="btn btn-md btn-primary-gradient rounded-pill">
                  Download
                </button>
                {/* </a> */}
              </li>
            </ul>							
          </div>
          <div className="view-prescribe-details p-0 border-0">
            {/* Invoice Item */}
            <div className="invoice-item">
              <div className="row">
                <div className="col-md-6">
                  <div className="invoice-info d-flex align-items-center">
                    <div className="clinic-image d-inline-flex align-items-center justify-content-center">
                      <img src="assets/img/icons/vtaplus.svg" alt="img" />
                    </div>
                    <div>
                      <h6 className="fs-16 fw-semibold">Vitalplus Clinic</h6>
                      <p className="fs-14 fw-medium">Dr. Sandy Maria</p>
                      <p className="fs-14">MBLS,MS</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="invoice-info2">
                    <p><span>Test Type : </span>CBC</p>
                    <p><span>Collected On : </span>20 Mar 2024, 10:00 AM</p>
                    <p><span>Reported On :</span>21 Mar 2024, 11:00 AM</p>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="patient-infos d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <div className="d-flex align-items-center">
                      <span className="avatar me-2">
                        <img src="assets/img/doctors-dashboard/profile-06.jpg" className="rounded" alt="img" />
                      </span>
                      <div>
                        <h6 className="fs-14 fw-medium">Hendrita Kearns</h6>
                        <p>Patient ID : PT254654</p>
                      </div>
                    </div>
                    <div>
                      <h6 className="fs-14 fw-medium">Gender</h6>
                      <p>Female</p>
                    </div>
                    <div>
                      <h6 className="fs-14 fw-medium">Age</h6>
                      <p>32 years </p>
                    </div>
                    <div>
                      <h6 className="fs-14 fw-medium">Blood</h6>
                      <p>O+</p>
                    </div>
                    <div>
                      <h6 className="fs-14 fw-medium">Type</h6>
                      <p>Outpatient</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Invoice Item */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
              <h6>Complete Blood Count(CBC)</h6>
              <p className="fs-14 mb-0"><span className="text-gray-9">Primary Test Type :</span> Blood</p>
            </div>
            {/* Invoice Item */}
            <div className="invoice-item invoice-table-wrap">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive inv-table">
                    <table className="invoice-table table table-bordered">
                      <thead>
                        <tr>
                          <th>Investigation</th>
                          <th>Result</th>
                          <th>Reference Value</th>
                          <th>Unit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="report-title" colSpan={4}>HEMOGLOBIN</td>
                        </tr>
                        <tr>
                          <td>Hemoglobin (Hb)</td>
                          <td>12.5<span className="badge badge-info-transparent text-xs d-inline-block rounded-pill ms-1">Low</span></td>
                          <td>13.0 - 17.0</td>
                          <td>g/dL</td>
                        </tr>
                        <tr>
                          <td className="report-title" colSpan={4}>RBC COUNT</td>
                        </tr>
                        <tr>
                          <td>Total RBC Count</td>
                          <td>5.2</td>
                          <td>4.5 - 5.5</td>
                          <td>million cells/µL</td>
                        </tr>
                        <tr>
                          <td className="report-title" colSpan={4}>BLOOD INDICES</td>
                        </tr>
                        <tr>
                          <td>Packed Cell Volume (PCV)</td>
                          <td className="text-danger">57.5<span className="badge badge-danger-transparent text-xs d-inline-block rounded-pill ms-1">High</span></td>
                          <td>40 - 50</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td>Mean Corpuscular Volume (MCV) <span className="fs-10 text-gray-6">Calculated</span></td>
                          <td>87.75</td>
                          <td>83 - 101</td>
                          <td>fL</td>
                        </tr>
                        <tr>
                          <td>MCH Calculated</td>
                          <td>27.72</td>
                          <td>27 - 32</td>
                          <td>pg</td>
                        </tr>
                        <tr>
                          <td>MCHC Calculated</td>
                          <td>32.8</td>
                          <td>32.5 - 34.5</td>
                          <td>g/dL</td>
                        </tr>
                        <tr>
                          <td>RDW</td>
                          <td>13.6</td>
                          <td>11.6 - 14.0</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td className="report-title" colSpan={4}>WBC COUNT</td>
                        </tr>
                        <tr>
                          <td>Total WBC Count</td>
                          <td>9000</td>
                          <td>4000 - 11000</td>
                          <td>cells/µL</td>
                        </tr>
                        <tr>
                          <td className="report-title" colSpan={4}>DIFFERENTIAL WBC COUNT</td>
                        </tr>
                        <tr>
                          <td>Neutrophils</td>
                          <td>60</td>
                          <td>50 - 62</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td>Lymphocytes</td>
                          <td>31</td>
                          <td>20 - 40</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td>Eosinophils</td>
                          <td>01</td>
                          <td>00 - 06</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td>Monocytes</td>
                          <td>07</td>
                          <td>00 - 10</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td>Basophils</td>
                          <td>01</td>
                          <td>00 - 02</td>
                          <td>%</td>
                        </tr>
                        <tr>
                          <td>Platelet Count</td>
                          <td>248157</td>
                          <td>150000 - 410000</td>
                          <td>µL</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* /Invoice Item */}
            <p className="mb-2"><span className="text-gray-9 fw-medium">Instruments :</span> Fully Automated Cell Counter - Mindray 300</p>
            <p className="mb-3"><span className="text-gray-9 fw-medium">Interpretation :</span> Further confirm for Anemia</p>
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="scan-wrap">
                  <h6>Scan to download report</h6>
                  <img src="assets/img/scan.png" alt="scan" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="prescriber-info">
                  <h6>Dr. Edalin Hendry</h6>
                  <p>Dept of Cardiology</p>
                </div>
              </div>
            </div>
            <ul className="nav inv-paginate justify-content-center">
              <li>Page 01 of 
                {/* <a> */}
                <button type="button" data-bs-toggle="modal" data-bs-target="#view_prescription2" data-bs-dismiss="modal">
                  02
                </button>
                {/* </a> */}
              </li>
            </ul>
          </div>	
        </div>
      </div>
    </div>
  </div>
  {/* /View Report */}
  {/*View Prescription */}
  <div className="modal fade custom-modals" id="view_prescription">
    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">View Prescription</h3>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>				
        <div className="modal-body pb-0">
          <div className="prescribe-download">
            <h5>21 Mar  2024</h5>
            <ul>
              <li>
                {/* <a> */}
                <button type="button" className="print-link">
                  <i className="isax isax-printer" />
                </button>
                {/* </a> */}
              </li>
              <li>
                {/* <a> */}
                <button type="button" className="btn btn-primary-gradient rounded-pill">
                  Download
                </button>
                {/* </a> */}
              </li>
            </ul>							
          </div>
          <div className="view-prescribe invoice-content mb-0">
            <div className="invoice-item">
              <div className="row">
                <div className="col-md-6">
                  <div className="invoice-logo">
                    <img src="assets/img/logo.svg" alt="logo" />
                  </div>
                </div>
                <div className="col-md-6">
                  <p className="invoice-details">
                    <strong>Prescription ID :</strong> #PR-123 <br />
                    <strong>Issued:</strong> 21 Mar 2024
                  </p>
                </div>
              </div>
            </div>
            {/* Invoice Item */}
            <div className="invoice-item">
              <div className="row">
                <div className="col-md-6">
                  <div className="invoice-info">
                    <h6 className="customer-text">Doctor Details</h6>
                    <p className="invoice-details invoice-details-two">
                      Edalin Hendry <br />
                      806 Twin Willow Lane, <br />
                      Newyork, USA <br />
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="invoice-info invoice-info2">
                    <h6 className="customer-text">Patient Details</h6>
                    <p className="invoice-details">
                      Adrian Marshall <br />
                      299 Star Trek Drive,<br />
                      Florida, 32405, USA <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* /Invoice Item */}
            {/* Invoice Item */}
            <div className="invoice-item invoice-table-wrap">
              <div className="row">
                <div className="col-md-12">
                  <h6>Prescription  Details</h6>
                  <div className="table-responsive">
                    <table className="invoice-table table table-bordered">
                      <thead>
                        <tr>
                          <th>Medicine Name</th>
                          <th>Dosage</th>
                          <th>Frequency</th>
                          <th>Duration</th>
                          <th>Timings</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Ecosprin 75MG [Asprin 75 MG Oral Tab]</td>
                          <td>75 mg <span>Oral Tab</span></td>
                          <td>1-0-0-1</td>
                          <td>1 month</td>
                          <td>Before Meal</td>
                        </tr>
                        <tr>
                          <td>Alexer 90MG Tab</td>
                          <td>90 mg <span>Oral Tab</span></td>
                          <td>1-0-0-1</td>
                          <td>1 month</td>
                          <td>Before Meal</td>
                        </tr>
                        <tr>
                          <td>Ramistar XL2.5</td>
                          <td>60 mg <span>Oral Tab</span></td>
                          <td>1-0-0-0</td>
                          <td>1 month</td>
                          <td>After Meal</td>
                        </tr>
                        <tr>
                          <td>Metscore</td>
                          <td>90 mg <span>Oral Tab</span></td>
                          <td>1-0-0-1</td>
                          <td>1 month</td>
                          <td>After Meal</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* /Invoice Item */}
            {/* Invoice Information */}
            <div className="other-info">
              <h4>Other information</h4>
              <p className="mb-0">An account of the present illness, which includes the circumstances surrounding the onset of recent health changes and the chronology of subsequent events that have led the patient to seek medicine</p>
            </div>
            <div className="other-info">
              <h4>Follow Up</h4>
              <p className="mb-0">Follow up after 3 months, Have to come on empty stomach</p>
            </div>
            <div className="prescriber-info">
              <h6>Dr. Edalin Hendry</h6>
              <p>Dept of Cardiology</p>
            </div>
            {/* /Invoice Information */}
          </div>	
        </div>
      </div>
    </div>
  </div>
  {/* /View Prescription */}		
  {/* Delete */}
  <div className="modal fade custom-modals" id="delete_modal">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body p-4 text-center">
          <form action="https://doccure.dreamstechnologies.com/html/template/medical-records.html">
            <span className="del-icon mb-2 mx-auto">
              <i className="isax isax-trash" />
            </span>
            <h3 className="mb-2">Delete Record</h3>
            <p className="mb-3">Are you sure you want to delete this record?</p>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              {/* <a> */}
              <button type="button" className="btn btn-md btn-dark rounded-pill" data-bs-dismiss="modal">
                Cancel
              </button>
              {/* </a> */}
              <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill">Yes Delete</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* /Delete */}


</>
    );
}
export default MedicalRecords;